module.exports = __webpack_public_path__ + "img/advance4.2a839f48.png";